import { useMemo } from 'react';
import { useCompliance } from '@/components/ComplianceProvider/ComplianceProvider';
import { useIsWalletACoinbaseSmartWallet } from '@/hooks/useIsWalletACoinbaseSmartWallet';

export function useAnalyticsUserMetadata() {
  const isSmartWallet = useIsWalletACoinbaseSmartWallet();
  const { isVerifiedAccount, isVerifiedCountry, attestationCountry } = useCompliance();

  return useMemo(() => {
    return {
      isSmartWallet,
      isVerifiedAccount,
      isVerifiedCountry,
      attestationCountry,
    };
  }, [isSmartWallet, isVerifiedAccount, isVerifiedCountry, attestationCountry]);
}
